import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function ReportBanner() {
  const { user } = useAuth();
  const reportLink = user ? '/report' : `/login?redirect=${encodeURIComponent('/report')}`;
  return (
    <section className="py-10 md:py-14 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
              <i className="ri-user-voice-line text-white text-2xl" />
            </div>
            <div>
              <h2 className="text-lg md:text-xl font-bold text-white">
                피해가 발생하셨다면, 지금 바로 제보해주세요
              </h2>
              <p className="text-sm text-white/80 mt-1">
                빠른 제보가 피해 확산을 방지하고 다른 사용자의 피해를 막을 수 있습니다.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <Link to={reportLink} className="bg-white hover:bg-background-50 text-primary-500 font-semibold px-6 py-3 rounded transition-colors whitespace-nowrap flex items-center gap-2">
              피해 제보하기
              <i className="ri-arrow-right-line" />
            </Link>

            <div className="flex items-center gap-4 text-white/90">
              <div className="flex flex-col items-center gap-1">
                <i className="ri-file-list-3-line text-lg" />
                <span className="text-[10px]">제보 접수</span>
              </div>
              <i className="ri-arrow-right-s-line text-xs" />
              <div className="flex flex-col items-center gap-1">
                <i className="ri-search-line text-lg" />
                <span className="text-[10px]">검증 진행</span>
              </div>
              <i className="ri-arrow-right-s-line text-xs" />
              <div className="flex flex-col items-center gap-1">
                <i className="ri-shield-check-line text-lg" />
                <span className="text-[10px]">안전 등급 게재</span>
              </div>
              <i className="ri-arrow-right-s-line text-xs" />
              <div className="flex flex-col items-center gap-1">
                <i className="ri-notification-3-line text-lg" />
                <span className="text-[10px]">등록 알림 및 처리</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}